import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Error } from "../ui/toaster";
import generateAction from "../../utils/action-helpers";
import { MESSAGES } from "../../state/actions";
import { messageState } from "../../utils/messajes";

const Download = React.memo(() => {
  const dispatch = useDispatch();
  const { downloadStatus } = useSelector(state => state.messages);
  const [downloadError, setDownloadError] = useState(downloadStatus === messageState.ERROR);

  useEffect(() => {
    setDownloadError(downloadStatus === messageState.ERROR);
  }, [downloadStatus, setDownloadError]);

  const updateDownloadStatus = () =>
    dispatch(generateAction(MESSAGES.DOWNLOAD_STATUS, messageState.IDLE));

  return (
    <div>
      <Error
        id="delete_error"
        visible={downloadError}
        title="Error al descargar"
        text="Se ha producido un error al descargar el fichero."
        onClose={updateDownloadStatus}
      />
    </div>
  );
});

export default Download;
